import { useEffect, useCallback } from "react";

/**
 * Hook para igualar la altura de elementos con una clase específica
 * dentro de un contenedor grid de 2 columnas.
 *
 * @param {string} containerSelector - Selector del contenedor grid
 * @param {string} elementSelector - Selector de los elementos a igualar
 * @param {Array} dependencies - Dependencias para recalcular
 */
const useEqualHeight = (
  containerSelector,
  elementSelector,
  dependencies = []
) => {
  const equalizeHeights = useCallback(() => {
    const container = document.querySelector(containerSelector);
    if (!container) {
      return;
    }

    const elements = container.querySelectorAll(elementSelector);
    if (!elements.length) {
      return;
    }

    elements.forEach((el) => {
      el.style.minHeight = "auto";
    });

    const containerWidth = container.offsetWidth;
    const isMobile = containerWidth < 1024;

    if (isMobile) {
      return;
    }

    const elementsArray = Array.from(elements);
    for (let i = 0; i < elementsArray.length; i += 2) {
      const row = elementsArray.slice(i, i + 2);

      if (row.length === 2) {
        const maxHeight = Math.max(...row.map((el) => el.offsetHeight));

        row.forEach((el) => {
          el.style.minHeight = `${maxHeight}px`;
        });
      }
    }
  }, [containerSelector, elementSelector]);

  useEffect(() => {
    const timeoutId = setTimeout(equalizeHeights, 100);
    window.addEventListener("resize", equalizeHeights);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", equalizeHeights);
    };
  }, [equalizeHeights, ...dependencies]);

  return equalizeHeights;
};

export default useEqualHeight;
